import { useSelector } from 'react-redux';
import {
  PROCESOS_ELECTORALES,
  PROCESOS_ESPECIFICOS,
  CONFIGURACION_SISTEMA
} from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { Form, Row, Input, Select, DatePicker, Col } from 'antd';
import { Button } from 'components';
import {
  DATE_FORMAT_DATE_PICKER,
  DATE_FORMAT_SLASH_00,
  DATE_FORMAT_SLASH_59
} from 'constants/dateFormat';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

export const BuscadorMonitoreo = ({ onSearch }) => {
  const [searchForm] = Form.useForm();
  const procesosElectorales = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const procesosEspecificos = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso.nombreProcesoEspecifico.replace('Ã±', 'ñ')
  }));
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  const validateDate = (_, dateValue) => {
    const { getFieldValue } = searchForm;
    const otherFieldValue = getFieldValue('fechaInicio'); // Compara las fechas
    if (otherFieldValue && dateValue.isBefore(otherFieldValue)) {
      return Promise.reject(Error('La fecha no puede ser anterior a la fecha inicial.'));
    }
    return Promise.resolve();
  };
  const handleSearchByFilters = async () => {
    try {
      const params = await searchForm.validateFields();
      if (params.folioDesde !== undefined) params.folioDesde = Number(params.folioDesde);
      if (params.folioHasta !== undefined) params.folioHasta = Number(params.folioHasta);
      if (params.folioCNCSDesde !== undefined)
        params.folioCNCSDesde = Number(params.folioCNCSDesde);
      if (params.folioCNCSHasta !== undefined)
        params.folioCNCSHasta = Number(params.folioCNCSHasta);
      // Formatear fechas si están definidas
      if (params.fechaInicio) {
        params.fechaInicio = params.fechaInicio.format(DATE_FORMAT_SLASH_00);
      }

      if (params.fechaFinal) {
        params.fechaFinal = params.fechaFinal.format(DATE_FORMAT_SLASH_59);
      }
      onSearch(params);
    } catch (error) {
      /* empty */
    }
  };

  const handleClearFilters = () => {
    searchForm.resetFields();
    onSearch({});
  };

  const validateInput = (_, value) => {
    const regex = /^[a-zA-Z0-9-]+$/;
    if (!value || regex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('El valor debe contener solo letras, números o guiones'));
  };

  return (
    <div className="buscador-monitoreo">
      <Form form={searchForm} layout="horizontal">
        <Row gutter={24}>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta">Proceso Electoral:</span>
            <Form.Item name="idProcesoGral">
              <Select
                placeholder="Filtra"
                allowClear
                options={procesosElectorales}
                fieldNames={{
                  value: 'idProcesoElectoral',
                  label: 'descripcion'
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta">Proceso:</span>
            <Form.Item name="idProcesoEspecifico" className="buscador-monitoreo-etiqueta">
              <Select
                placeholder="Filtra"
                allowClear
                options={procesosEspecificos}
                fieldNames={{
                  value: 'idProcesoEspecifico',
                  label: 'nombreProcesoEspecifico'
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta">Fecha:</span>
            <Form.Item name="fechaInicio" label="Desde:" className="buscador-monitoreo-etiqueta">
              <DatePicker
                placeholder="Fecha inicio"
                allowClear
                format={DATE_FORMAT_DATE_PICKER}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
              />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta" />
            <Form.Item
              name="fechaFinal"
              label="Hasta:"
              className="buscador-monitoreo-etiqueta"
              labelAlign="left"
              rules={[
                {
                  validator: validateDate
                }
              ]}>
              <DatePicker
                placeholder="Fecha Final"
                allowClear
                format={DATE_FORMAT_DATE_PICKER}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta">Folio de monitoreo:</span>
            <Form.Item
              name="folioDesde"
              label="Desde INE-MI-"
              labelAlign="left"
              className="buscador-monitoreo-etiqueta">
              <Input placeholder="Filtra" type="number" />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta" />

            <Form.Item
              name="folioHasta"
              label="Hasta INE-MI-"
              className="buscador-monitoreo-etiqueta">
              <Input placeholder="Filtra" type="number" />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta">Folio CNCS:</span>
            <Form.Item
              name="folioCNCSDesde"
              label="Desde:"
              labelAlign="left"
              className="buscador-monitoreo-etiqueta"
              rules={[{ validator: validateInput }]}>
              <Input placeholder="Filtra" type="number" />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <span className="buscador-monitoreo-etiqueta" />

            <Form.Item
              name="folioCNCSHasta"
              label="Hasta:"
              className="buscador-monitoreo-etiqueta"
              rules={[{ validator: validateInput }]}>
              <Input placeholder="Filtra" type="number" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className="buscador-monitoreo-acciones">
        <Button text="Limpiar" onClick={handleClearFilters} />
        <span style={{ width: '1em' }} />
        <Button text="Buscar" type="primary" onClick={handleSearchByFilters} />
      </div>
    </div>
  );
};

BuscadorMonitoreo.propTypes = {
  onSearch: PropTypes.func.isRequired
};
